.summary {
	background: #fafafa;
	border-bottom: 1px solid #e5e7eb;
	padding: 0.75rem 1rem;
	display: flex;
	align-items: center;
	gap: 1.5rem;

	&.default {
		border-left: 2px solid #6b7280;
	}

	&.success {
		border-left: 2px solid #10b981;
		background: rgba(16, 185, 129, 0.02);
	}

	&.warning {
		border-left: 2px solid #f59e0b;
		background: rgba(245, 158, 11, 0.02);
	}

	&.info {
		border-left: 2px solid #3b82f6;
		background: rgba(59, 130, 246, 0.02);
	}
}

.badgeContainer {
	display: flex;
	align-items: center;
	flex-shrink: 0;
}

.items {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 1.25rem;
	flex: 1;
}

.item {
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
}

.label {
	font-size: 0.6875rem;
	font-weight: 600;
	color: #6b7280;
	text-transform: uppercase;
	letter-spacing: 0.025em;
}

.value {
	font-size: 0.875rem;
	font-weight: 600;
	color: #111827;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
